import { render, staticRenderFns } from "./farmAdmin.vue?vue&type=template&id=0c2b337d&scoped=true&"
import script from "./farmAdmin.vue?vue&type=script&lang=js&"
export * from "./farmAdmin.vue?vue&type=script&lang=js&"
import style0 from "./farmAdmin.vue?vue&type=style&index=0&id=0c2b337d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2b337d",
  null
  
)

export default component.exports